/* ==========================================================================
   00FIERCE — STICKER-KARUSSELL, neue Layouts (v3.4 · Okt 2026)
   <khs-sticker-carousel data-layout="stage|loop|stack|rail|focus">
   Gehoert zu snippets/khs-sticker-carousel.liquid und
   assets/khs-sticker-carousel.css.

   stage  Bühne: aktive Karte genau in der Mitte, Nachbarn etwas kleiner
   loop   Endlos: wie Bühne, nach der letzten Karte kommt die erste
   stack  Stapel: oberste Karte zur Seite wischen, sie wandert nach hinten
   focus  Fokus: eine Karte, darunter Vorschauen zum Hinspringen
   rail   Leiste: native Scroll-Leiste, hier nur Breite, Pfeile und Linie

   Wischen (Finger oder Maus), Pfeile, Pfeiltasten und Antippen der
   Nachbarkarte. Nach einem Wisch wird der Link der Karte nicht geöffnet.
   ========================================================================== */
(function () {
  'use strict';
  if (window.customElements && customElements.get('khs-sticker-carousel')) return;
  if (!window.customElements) return;

  var DESK = '(min-width: 750px)';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function num(v, d) { var n = parseFloat(v); return isFinite(n) ? n : d; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  class KhsStickerCarousel extends HTMLElement {
    connectedCallback() {
      if (this.__ready) return;
      this.__ready = true;

      var d = this.dataset;
      this.layout = d.layout || 'stage';
      this.stage = this.querySelector('[data-sc-stage]');
      this.track = this.querySelector('[data-sc-track]');
      this.items = Array.prototype.slice.call(this.querySelectorAll('[data-sc-item]'));
      this.n = this.items.length;
      if (!this.stage || !this.n) return;

      this.cardM = num(d.cardM, 68);
      this.cardD = num(d.cardD, 26);
      this.gap = num(d.gap, 12);
      this.sideScale = num(d.sideScale, 88) / 100;
      this.sideOpacity = num(d.sideOpacity, 100) / 100;
      this.tap = d.tap !== 'false';
      this.wrap = d.wrap === 'true';
      this.tilt = num(d.tilt, 3.5);
      this.railM = num(d.railM, 1.6);
      this.railD = num(d.railD, 4.25);
      this.loop = this.layout === 'loop' && this.n >= 3;
      this.prevBtn = this.querySelector('[data-sc-prev]');
      this.nextBtn = this.querySelector('[data-sc-next]');
      this.countEl = this.querySelector('[data-sc-count]');
      this.bar = this.querySelector('[data-sc-bar]');
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-sc-go]'));

      this.active = clamp(parseInt(d.start, 10) || 0, 0, this.n - 1);
      this.pos = this.active;            /* Bühne/Endlos/Fokus: Position als Kommazahl */
      this.order = [];                   /* Stapel: Reihenfolge von oben nach unten */
      for (var i = 0; i < this.n; i++) this.order.push((i + this.active) % this.n);
      this.drag = null;
      this.suppressUntil = 0;

      this.style.setProperty('--sc-gap', this.gap + 'px');
      this.classList.add('is-ready');

      var self = this;
      this.onResize = function () { self.layoutAll(false); };
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(function () { window.requestAnimationFrame(self.onResize); });
        this.ro.observe(this);
      } else {
        window.addEventListener('resize', this.onResize);
      }

      if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.step(-1); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.step(1); });
      this.thumbs.forEach(function (b) {
        b.addEventListener('click', function () { self.goTo(parseInt(b.getAttribute('data-sc-go'), 10)); });
      });

      if (this.layout === 'rail') {
        this.items.forEach(function (li) { li.classList.add('is-active'); });
        this.stage.addEventListener('scroll', function () {
          if (self.railFrame) return;
          self.railFrame = window.requestAnimationFrame(function () { self.railFrame = 0; self.paintRail(); });
        }, { passive: true });
      } else {
        this.bindDrag();
        this.stage.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); self.step(1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); self.step(-1); }
        });
      }
      /* nach einem Wisch keinen Link öffnen; Nachbarkarte antippen = in die Mitte holen */
      this.addEventListener('click', function (e) { self.onClick(e); }, true);
      this.addEventListener('dragstart', function (e) { if (self.layout !== 'rail') e.preventDefault(); });

      this.layoutAll(false);
      /* Bilder laden nach: Höhe der Karten neu messen */
      this.items.forEach(function (li) {
        li.querySelectorAll('img').forEach(function (img) {
          if (!img.complete) img.addEventListener('load', self.onResize, { once: true });
        });
      });
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
      window.removeEventListener('resize', this.onResize);
      this.__ready = false;
    }

    isDesk() { return window.matchMedia ? window.matchMedia(DESK).matches : false; }

    /* ---------- Maße ---------- */
    layoutAll(animate) {
      var W = this.stage.clientWidth;
      if (!W) return;
      this.W = W;
      var desk = this.isDesk();
      if (this.layout === 'rail') {
        var gut = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
        var v = desk ? this.railD : this.railM;
        this.w = Math.max(120, (W - gut - this.gap * Math.floor(v)) / v);
        this.style.setProperty('--sc-w', this.w + 'px');
        this.paintRail();
        return;
      }
      var pct = desk ? this.cardD : this.cardM;
      if (this.layout === 'stack') pct = Math.min(pct + 2, 92);
      if (this.layout === 'focus') pct = Math.min(pct + 6, 92);
      this.w = W * pct / 100;
      this.style.setProperty('--sc-w', this.w + 'px');
      var h = 0;
      this.items.forEach(function (li) { h = Math.max(h, li.offsetHeight); });
      this.h = h;
      this.padY = this.layout === 'stack' ? 26 : 22;
      var extra = this.layout === 'stack' ? 42 : 0;
      this.stage.style.height = Math.round(h + this.padY * 2 + extra) + 'px';
      this.render(!!animate);
    }

    /* ---------- Darstellung ---------- */
    wrapDist(i, p) {
      var dd = i - p;
      if (!this.loop) return dd;
      var n = this.n;
      while (dd > n / 2) dd -= n;
      while (dd < -n / 2) dd += n;
      return dd;
    }

    render(animate, dragX) {
      this.classList.toggle('is-anim', !!animate && !reduce);
      var self = this, W = this.W, w = this.w, gap = this.gap, y = this.padY;
      dragX = dragX || 0;

      if (this.layout === 'stack') {
        var pattern = [-0.7, 0.6, -0.35, 0.85];
        var x0 = W / 2 - w / 2;
        this.order.forEach(function (ci, k) {
          var li = self.items[ci];
          var rot = self.tilt * pattern[ci % 4];
          var depth = Math.min(k, 3);
          var t;
          if (k === 0) {
            t = 'translate(' + (x0 + dragX) + 'px,' + y + 'px) rotate(' + (rot * 0.4 + dragX / 22) + 'deg)';
          } else {
            var dx = (k % 2 ? 14 : -12) * Math.min(k, 2);
            t = 'translate(' + (x0 + dx) + 'px,' + (y + depth * 12) + 'px) rotate(' + (rot * 1.4) + 'deg) scale(' + (1 - depth * 0.035) + ')';
          }
          li.style.transform = t;
          li.style.zIndex = String(50 - k);
          li.style.opacity = k > 3 ? '0' : '1';
          self.setLive(li, k === 0, k <= 3);
        });
        this.active = this.order[0];
      } else if (this.layout === 'focus') {
        var p = this.pos;
        this.items.forEach(function (li, i) {
          var dd = i - p;
          var x = W / 2 - w / 2 + dd * (W * 0.9) + dragX;
          li.style.transform = 'translate(' + x + 'px,' + y + 'px)';
          var vis = dragX ? Math.abs(dd) <= 1 : Math.abs(dd) < 0.5;
          li.style.opacity = vis ? '1' : '0';
          li.style.zIndex = Math.abs(dd) < 0.5 ? '2' : '1';
          self.setLive(li, Math.abs(dd) < 0.5, vis);
        });
        this.active = clamp(Math.round(this.pos), 0, this.n - 1);
      } else {
        var pp = this.pos;
        this.items.forEach(function (li, i) {
          var dd = self.wrapDist(i, pp);
          var ad = Math.min(1, Math.abs(dd));
          var sc = 1 - (1 - self.sideScale) * ad;
          var x = W / 2 - w / 2 + dd * (w + gap);
          li.style.transform = 'translate(' + x + 'px,' + y + 'px) scale(' + sc + ')';
          li.style.opacity = String(1 - (1 - self.sideOpacity) * ad);
          li.style.zIndex = String(10 - Math.round(Math.abs(dd) * 2));
          var shown = Math.abs(dd) < 2.2;
          li.style.visibility = shown ? '' : 'hidden';
          self.setLive(li, Math.abs(dd) < 0.5, Math.abs(dd) < 1.5);
        });
        this.active = ((Math.round(this.pos) % this.n) + this.n) % this.n;
      }
      this.paintControls();
    }

    /* aktive Karte markieren; Karten außerhalb nicht per Tab erreichbar */
    setLive(li, isActive, reachable) {
      li.classList.toggle('is-active', isActive);
      if (isActive) li.setAttribute('aria-current', 'true'); else li.removeAttribute('aria-current');
      if (reachable && (isActive || this.layout === 'stage' || this.layout === 'loop')) {
        li.removeAttribute('inert');
        li.removeAttribute('aria-hidden');
      } else {
        li.setAttribute('inert', '');
        li.setAttribute('aria-hidden', 'true');
      }
    }

    paintControls() {
      var a = this.active;
      if (this.countEl) this.countEl.textContent = (a + 1) + ' / ' + this.n;
      this.thumbs.forEach(function (b, i) {
        b.classList.toggle('is-on', i === a);
        b.setAttribute('aria-pressed', String(i === a));
      });
      var endless = this.loop || this.layout === 'stack' || this.wrap;
      if (this.prevBtn) this.prevBtn.disabled = !endless && a <= 0;
      if (this.nextBtn) this.nextBtn.disabled = !endless && a >= this.n - 1;
    }

    paintRail() {
      var st = this.stage, max = st.scrollWidth - st.clientWidth;
      if (this.bar) {
        var part = st.scrollWidth ? st.clientWidth / st.scrollWidth : 1;
        this.bar.style.width = (Math.min(1, part) * 100) + '%';
        var prog = max > 0 ? st.scrollLeft / max : 0;
        this.bar.style.transform = 'translateX(' + (prog * (1 / Math.min(1, part) - 1) * 100) + '%)';
      }
      if (this.prevBtn) this.prevBtn.disabled = st.scrollLeft < 4;
      if (this.nextBtn) this.nextBtn.disabled = st.scrollLeft > max - 4;
    }

    /* ---------- Bewegung ---------- */
    step(dir) {
      if (this.layout === 'rail') {
        this.stage.scrollBy({ left: dir * (this.w + this.gap), behavior: reduce ? 'auto' : 'smooth' });
        return;
      }
      if (this.layout === 'stack') {
        if (dir > 0) this.throwTop(-1); else this.bringBack();
        return;
      }
      var target = Math.round(this.pos) + dir;
      if (!this.loop && this.wrap) {
        if (target < 0) target = this.n - 1;
        if (target > this.n - 1) target = 0;
      }
      this.goTo(target, true);
    }

    goTo(i, fromStep) {
      if (this.layout === 'rail') {
        var li = this.items[clamp(i, 0, this.n - 1)];
        this.stage.scrollTo({ left: li.offsetLeft - (parseFloat(getComputedStyle(this.track).paddingLeft) || 0), behavior: reduce ? 'auto' : 'smooth' });
        return;
      }
      if (this.layout === 'stack') {
        var guard = 0;
        while (this.order[0] !== i && guard++ < this.n) this.order.push(this.order.shift());
        this.render(true);
        return;
      }
      if (this.loop) {
        var cur = Math.round(this.pos);
        var target = fromStep ? i : cur + this.wrapDist(((i % this.n) + this.n) % this.n, cur);
        this.pos = target;
      } else {
        this.pos = clamp(i, 0, this.n - 1);
      }
      this.render(true);
    }

    throwTop(dir) {
      var self = this, li = this.items[this.order[0]];
      this.classList.add('is-anim');
      li.style.transform = 'translate(' + (this.W / 2 - this.w / 2 + dir * this.W * 1.05) + 'px,' + (this.padY + 20) + 'px) rotate(' + (dir * 18) + 'deg)';
      window.setTimeout(function () { self.order.push(self.order.shift()); self.render(true); }, reduce ? 0 : 230);
    }

    bringBack() {
      var last = this.order.pop();
      this.order.unshift(last);
      var li = this.items[last];
      this.classList.remove('is-anim');
      li.style.zIndex = '60';
      li.style.transform = 'translate(' + (this.W / 2 - this.w / 2 - this.W * 1.05) + 'px,' + (this.padY + 20) + 'px) rotate(-18deg)';
      void li.offsetWidth;
      this.render(true);
    }

    /* ---------- Wischen ---------- */
    bindDrag() {
      var self = this, st = this.stage;
      st.addEventListener('pointerdown', function (e) {
        if (e.button > 0) return;
        if (e.target.closest('.khs-qa')) return; /* Plus-Button nicht als Wisch zählen */
        if (self.layout === 'stack') {
          var it = e.target.closest('[data-sc-item]');
          if (!it || self.items.indexOf(it) !== self.order[0]) return;
        }
        self.drag = { id: e.pointerId, x: e.clientX, y: e.clientY, t: Date.now(), p0: self.pos, moved: false, dx: 0 };
      });
      st.addEventListener('pointermove', function (e) {
        var g = self.drag;
        if (!g || g.id !== e.pointerId) return;
        var dx = e.clientX - g.x, dy = e.clientY - g.y;
        if (!g.moved) {
          if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 6) { self.drag = null; return; }
          if (Math.abs(dx) < 7) return;
          g.moved = true;
          st.classList.add('is-drag');
          try { st.setPointerCapture(e.pointerId); } catch (err) { /* egal */ }
        }
        g.dx = dx;
        if (self.layout === 'stack') { self.render(false, dx); return; }
        if (self.layout === 'focus') {
          var edge = (self.pos <= 0 && dx > 0) || (self.pos >= self.n - 1 && dx < 0);
          self.render(false, edge ? dx * 0.3 : dx);
          return;
        }
        var p = g.p0 - dx / (self.w + self.gap);
        if (!self.loop) {
          if (p < 0) p = p * 0.3;
          if (p > self.n - 1) p = self.n - 1 + (p - self.n + 1) * 0.3;
        }
        self.pos = p;
        self.render(false);
      });
      var end = function (e) {
        var g = self.drag;
        if (!g || g.id !== e.pointerId) return;
        self.drag = null;
        st.classList.remove('is-drag');
        if (!g.moved) return;
        self.suppressUntil = Date.now() + 350;
        var dt = Date.now() - g.t, dx = g.dx;
        var flick = Math.abs(dx) > 18 && dt < 260;
        if (self.layout === 'stack') {
          if (Math.abs(dx) > Math.min(self.W * 0.2, self.w * 0.32) || flick) self.throwTop(dx < 0 ? -1 : 1);
          else self.render(true, 0);
          return;
        }
        if (self.layout === 'focus') {
          var go = self.active;
          if (Math.abs(dx) > Math.min(self.W * 0.18, self.w * 0.3) || flick) go = self.active + (dx < 0 ? 1 : -1);
          self.pos = clamp(go, 0, self.n - 1);
          self.render(true);
          return;
        }
        var t = Math.round(self.pos);
        if (flick && t === Math.round(g.p0)) t += dx < 0 ? 1 : -1;
        if (!self.loop) t = clamp(t, 0, self.n - 1);
        self.pos = t;
        self.render(true);
      };
      st.addEventListener('pointerup', end);
      st.addEventListener('pointercancel', end);
    }

    onClick(e) {
      if (Date.now() < this.suppressUntil) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      if (this.layout !== 'stage' && this.layout !== 'loop') return;
      var li = e.target.closest('[data-sc-item]');
      if (!li || li.classList.contains('is-active')) return;
      if (!this.tap) return;
      e.preventDefault();
      e.stopPropagation();
      this.goTo(this.items.indexOf(li));
    }
  }

  customElements.define('khs-sticker-carousel', KhsStickerCarousel);
})();
